"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContainer = void 0;
const focus_trap_react_1 = __importDefault(require("focus-trap-react"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importDefault(require("styled-components"));
const Container = styled_components_1.default.div `
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
	background-color: ${({ theme }) => theme.blackTransparent};

  .modal-content {
    margin: 10% auto;
    padding: 20px;
    background-color: ${({ theme }) => theme.white};
    box-shadow: 0px 3px 6px ${({ theme }) => theme.blackContainer};
    border-radius: 4px;
		max-width: 80%;

	@media (max-width: 41em) {
		padding: 10px;
		max-width: calc(80% + 10px);
		}
  }
`;
const ModalContainer = ({ children, ariaLabelledBy, mainContainerIdToHide, translatedKeys }) => {
    const i18n = react_i18next_1.useTranslation();
    const modalRef = react_1.useRef(null);
    react_1.useEffect(() => {
        const applicationNode = document.getElementById(mainContainerIdToHide);
        const restoreFocusOnElement = document.activeElement;
        setTimeout(() => {
            applicationNode && applicationNode.setAttribute('aria-hidden', 'true');
            modalRef.current && modalRef.current.focus();
        }, 0);
        return () => {
            setTimeout(() => {
                applicationNode && applicationNode.removeAttribute('aria-hidden');
                restoreFocusOnElement.focus();
            }, 0);
        };
    }, [mainContainerIdToHide]);
    return (react_1.default.createElement(focus_trap_react_1.default, null,
        react_1.default.createElement(Container, null,
            react_1.default.createElement("div", { id: 'modal-container', className: 'modal-content', "aria-modal": 'true', tabIndex: -1, ref: modalRef, "aria-labelledby": `modal-text ${ariaLabelledBy}` },
                react_1.default.createElement("span", { id: 'modal-text', className: 'sr-only' }, translatedKeys.startOfDialog),
                children,
                react_1.default.createElement("span", { className: 'sr-only' }, translatedKeys.endOfDialog)))));
};
exports.ModalContainer = ModalContainer;
